import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreCardTypes as orgConfig } from 'org/configs/modules.config';
import amexImage from 'core/assets/images/icons/card_amex.svg';
import visaImage from 'core/assets/images/icons/card_visa.svg';
import mastercardImage from 'core/assets/images/icons/card_mastercard.svg';

const defaultConfig = {
  defaults: {
    cardImages: {
      visa: visaImage,
      mastercard: mastercardImage,
      amex: amexImage,
    },
    cardNames: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'Amex',
    },
  },
};

const config = mergeModuleConfigs(defaultConfig, orgConfig);

const { cardImages, cardNames } = config;

export const cardTypeNames = {
  VISA: cardNames.visa,
  MASTERCARD: cardNames.mastercard,
  AMEX: cardNames.amex,
};

export const cardTypeImages = {
  VISA: cardImages.visa,
  MASTERCARD: cardImages.mastercard,
  AMEX: cardImages.amex,
};
